<template>
    <div>
      <b-navbar toggleable="sm" type="dark" fixed="top">
        <b-container fluid>
          <b-navbar-brand left href="#">
            <b-button  variant="link" @click= "alternarMenu">
              <font-awesome-icon  icon="bars"/>
            </b-button>
            <b-navbar-brand href="#">
              <img src="../assets/logo.png" alt="Kitten">
            </b-navbar-brand>
          </b-navbar-brand>
          <b-navbar-toggle class="btn" target="nav-collapse">
            <template>
              <b-nav-text @click= "close">
                <h6 class="m-0">{{title}}</h6>
              </b-nav-text>
            </template>
          </b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav v-model = "closeCollapse">
            <b-navbar-nav class="ml-auto">
              <b-nav-item v-for="(item, index) in menu" v-bind:key='index' :to="item.to"
              :active="isActive(item)">{{item.title}}</b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-container>
      </b-navbar>
    </div>
</template>

<script>
export default {
  props: [
    'open',
    'menu'
  ],
  data () {
    return {
      title: '',
      closeCollapse: false
    }
  },
  methods: {
    alternarMenu () {
      this.openProp = !this.open
      this.closeCollapse = false
    },
    isActive (item) {
      if (item.active) {
        this.title = item.title
        return true
      }
      return false
    },
    close () {
      this.openProp = false
    }
  },
  computed: {
    openProp: {
      get () { return this.open },
      set (val) { this.$emit('update:open', val) }
    }
  },
  async created () {
    console.log('nav bar')
    const path = await this.$router.currentRoute.path
    console.log('path', path)
    console.log('split', path.split('/'))
  }
}
</script>

<style scoped>
  /**/
  nav {
    /*font-family: "Heebo-ExtraBold";*/
    font-family: "Poppins-Light";
    background-color: #282828 !important;
  }
  /**/
  nav > div > a{
    color: #ffffffdb !important;
    font-size: 26px !important;
  }

  /* boton menu izquierdo y derecho*/
  nav > div > a > button,
  nav > div > ul > svg,
  /**/
  .navbar-toggler.collapsed,
  .navbar-toggler.not-collapsed
  {
    font-size: 24px !important;
    padding: 1px 0px!important;
    margin: 0px 10px !important;
    border: 0 !important;
    color: #ffffffdb !important;
    text-decoration: none !important;
    box-shadow: none !important;
  }
  nav > div > .navbar-brand img{
      width: 160px;
      margin-top: -5px;
  }
  .navbar-nav .nav-link{
    color: #FFF !important;
    font-size: 14px !important;
  }
  .navbar-nav .nav-link:hover,
  .nav-item .nav-link.active {
    color: #F4C96C !important;
  }
</style>
